import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_6 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Từ thời gian: ", -1)
const _hoisted_8 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Đến thời gian: ", -1)
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_11 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_15 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, { header: "SÀNG LỌC BỆNH KLN VÀ KHÁM SỨC KHỎE ĐỊNH KỲ" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Panel, { header: "Thời gian báo cáo" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_Calendar, {
                          modelValue: $setup.baoCao.tuThang,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.baoCao.tuThang) = $event)),
                          touchUI: "",
                          view: "month",
                          dateFormat: "mm/yy"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode(_component_Calendar, {
                          modelValue: $setup.baoCao.denThang,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.baoCao.denThang) = $event)),
                          touchUI: "",
                          view: "month",
                          dateFormat: "mm/yy"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_DataTable, {
                value: $setup.baoCao.baoCaos,
                showGridlines: "",
                rows: 40,
                rowHover: true,
                style: {"font-size":"14px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "TT",
                            colspan: 1,
                            style: {"width":"5px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Tên đơn vị",
                            colspan: 1,
                            style: {"width":"200px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người được đo huyết áp",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người được xác định nghi ngờ THA (Chỉ số huyết áp ≥140/90)",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người được sàng lọc nguy cơ ĐTĐ bằng bộ câu hỏi",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người được xác định nguy cơ cao ĐTĐ",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người được xét nghiệm đường huyết",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người nghi ngờ rối loạn đường huyết (ĐH >=5,6mmol/L)",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người được sàng lọc BPTNMT/ hen phế quản",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người nghi ngờ mắc BPTNMT/ hen phế quản",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người được sàng lọc các bệnh ung thư",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người nghi ngờ mắc ung thư",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người được khám sức khỏe định kỳ",
                            colspan: 1,
                            style: {"width":"100px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Tỷ lệ % người được khám sức khỏe định kỳ so với tổng dân số ≥ 18 tuổi(70% dân số)",
                            colspan: 1,
                            style: {"width":"100px"}
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "1",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "2",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "3",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "4",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "5",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "6",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "7",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "8",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "9",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "10",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "11",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "12",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "13",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "14",
                            colspan: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "",
                    style: {"width":"5px"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSo",
                    header: "Tổng số"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("label", null, _toDisplayString(slotProps.data.tenDonVi), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "soTrucThuoc",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiDoHuyetAp,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiDoHuyetAp) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "soCSCoYeuToCoHai",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiTHA,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiTHA) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoCoSo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiDuocSangLocNguyCoDTD,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiDuocSangLocNguyCoDTD) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongNuCoSo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiDuocXacDinhNguyCoCaoDTD,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiDuocXacDinhNguyCoCaoDTD) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoCoSoCoYeuTo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiDuocXNDuongHuyet,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiDuocXNDuongHuyet) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongNuCoSoCoYeuTo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiNghiNgoRoiLoanDH,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiNghiNgoRoiLoanDH) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiDuocSangLocHenPheQuan,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiDuocSangLocHenPheQuan) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiNghiNgoMacHenPheQuan,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiNghiNgoMacHenPheQuan) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiDuocSangLocCacBenhUngThu,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiDuocSangLocCacBenhUngThu) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiNghiNgoMacBenhUngThu,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiNghiNgoMacBenhUngThu) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiDuocKhamSucKhoeDinhKy,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiDuocKhamSucKhoeDinhKy) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.tyLeNguoiKhamSucKhoeDinhKy,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tyLeNguoiKhamSucKhoeDinhKy) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Button, {
                label: "Gởi báo cáo",
                icon: "pi pi-upload",
                severity: "secondary",
                raised: "",
                onClick: $setup.addReport
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}